import { useEffect, useState } from "react";
import BodyHeader from "../../../components/common/CommonBodyHeader";
import CustomTable from "../../../components/common/CustomTable";
import { loadingReportMasterAsync } from "../../../redux/features/report-master/loadingReportMasterSlice";
import { useDispatch, useSelector } from "react-redux";
import { backdropLoadingAction } from "../../../redux/features/helperSlice";
import toast from "react-hot-toast";
import * as XLSX from "xlsx";
import { useBoolean } from "../../../Hooks/useBoolean";
import { Stack } from "@mui/material";
import DownloadReportButton from "../../../components/common/DownloadReportButton";
import { tripExpensesSummaryMasterAsync } from "../../../redux/features/report-master/tripExpensesSummaryReportMasterSlice";
import { useFormik } from "formik";
import CustomDropdown from "../../../components/common/CustomDropdown/CustomDropdown";
import CustomInput from "../../../components/common/CustomInput/CustomInput";
import { useNavigate } from "react-router-dom";
import { BsFillEyeFill } from "react-icons/bs";

export default function TripExpensesReport() {
   const dispatch = useDispatch();
   const navigate = useNavigate();
   const [records, setRecords] = useState([]);

   const formatCurrency = (value) => {
      const amount = Number(value);
      if (Number.isNaN(amount)) return "-";
      return amount.toLocaleString("en-IN", {
         style: "currency",
         currency: "INR",
         minimumFractionDigits: 2,
         maximumFractionDigits: 2,
      });
   };

   const reportMasterList = useSelector(
      (state) => state.tripExpensesSummaryReportMasterSlice.data,
   );

   const columns = [
      {
         name: "Vehicle No.",
         selector: (row) => row?.vehicle_no,
         sortable: true,
      },
      {
         name: "Company Name",
         selector: (row) => row?.company_name,
         sortable: true,
      },

      {
         name: "Attach Location",
         selector: (row) => row?.attached_location,
         sortable: true,
      },

      {
         name: "Driver",
         selector: (row) => row?.driver_name,
         sortable: true,
      },

      {
         name: "Total Expense",
         selector: (row) => formatCurrency(row?.total_expense),
         sortable: true,
      },

      {
         name: "Action",
         selector: (row) => (
            <button
               className="btn"
               onClick={() => navigate("/trip/contractual/edit/" + row.tripid)}
            >
               <BsFillEyeFill
                  className="text-primary"
                  style={{ height: "1.5rem", width: "1.5rem" }}
               />
            </button>
         ),
         width: "120px",
         center: true,
      },
   ];

   /// fetching filter drop down values
   const dropDownMaster = useSelector((state) => state.reportDropDownRecordSlice);

   const companyData = [
      { label: "Select..", value: "" },
      ...(dropDownMaster?.data?.company_list?.map?.((item) => ({
         label: item?.company_name,
         value: item?.id,
      })) || []),
   ];

   const fleetData = [
      { label: "Select..", value: "" },
      ...(dropDownMaster?.data?.vehicle_list?.map?.((item) => ({
         label: item?.vehicle_no,
         value: item?.id,
      })) || []),
   ];

   const formik = useFormik({
      initialValues: {
         company: "",
         fleet: "",
         customer: "",
         tripCreatedFrom: "",
         tripCreatedTo: "",
      },

      //vlidationSchema: validationSchema,

      //onSubmit: handleAddVehicleDetails,
   });

   const { errors, values, touched, getFieldProps, handleSubmit, setFieldValue } = formik;

   const reportPopup = useBoolean();

   useEffect(() => {
      dispatch(backdropLoadingAction(true));
      const filter_params = {};
      if (values.company) filter_params.company_id = values.company;
      if (values.fleet) filter_params.vehicle_id = values.fleet;
      if (values.tripCreatedFrom)
         filter_params.trip_created_from = values.tripCreatedFrom;
      if (values.tripCreatedTo) filter_params.trip_created_to = values.tripCreatedTo;

      dispatch(
         tripExpensesSummaryMasterAsync({
            data: filter_params,
            done: () => {
               dispatch(backdropLoadingAction(false));
            },
            err: (error) => {
               dispatch(backdropLoadingAction(false));
               //toast.error(error);
            },
         }),
      );
   }, [values.company, values.fleet, values.tripCreatedFrom, values.tripCreatedTo]);

   useEffect(() => {
      if (reportMasterList) {
         const transformedRecords = Object.values(reportMasterList);
         const sortedRecords = transformedRecords.sort((a, b) => {
            let comp = a.company_name?.localeCompare(b.company_name);
            if (comp !== 0) return comp;

            comp = a.vehicle_no?.localeCompare(b.vehicle_no);
            if (comp !== 0) return comp;

            comp = a.customer?.localeCompare(b.customer);
            if (comp !== 0) return comp;

            return 0; // if all same
         });

         setRecords(sortedRecords);
      }
   }, [reportMasterList]);

   /*
   const handleDownloadReport = (data) => {
      dispatch(backdropLoadingAction(true));

      const filter_params = { data };

      if (values.company) filter_params.company_id = values.company;
      if (values.fleet) filter_params.vehicle_id = values.fleet;
      if (values.customer) filter_params.customer_id = values.customer;
      if (values.tripCreatedFrom)
         filter_params.trip_created_from = values.tripCreatedFrom;
      if (values.tripCreatedTo)
         filter_params.trip_created_to = values.tripCreatedTo;

      dispatch(
         tripExpensesSummaryMasterAsync({
            data: filter_params,
            err: () => {
               dispatch(backdropLoadingAction(false));
            },

            done: (report_list) => {
               const headers = [
                  "S. No.",
                  "Vehicle Number",
                  "Attached Location",
                  "Company name",
                  "Driver Name",
                  "HSD",
                  "Food exp",
                  "Police",
                  "Parking",
                  "Loading Chg.",
                  "Unloading Chg.",
                  "Misc Exp.",
               ];

               // Convert to array
               let list = Object.values(report_list);

               list.sort((a, b) => {
                  let comp = (a.company_name ?? "").localeCompare(b.company_name ?? "");
                  if (comp !== 0) return comp;

                  comp = (a.vehicle_no ?? "").localeCompare(b.vehicle_no ?? "");
                  if (comp !== 0) return comp;

                  comp = (a.customer ?? "").localeCompare(b.customer ?? "");
                  if (comp !== 0) return comp;

                  return 0;
               });

               const emiArr = [];

               list.forEach((item, index) => {
                  emiArr.push([
                     index + 1,
                     item?.vehicle_no ?? "-",
                     item?.attached_location ?? "-",
                     item?.company_name ?? "-",
                     item?.driver_name ?? "-",
                     item?.hsd ?? "-",
                     item?.food ?? "-",
                     item?.police ?? "-",
                     item?.parking ?? "-",
                     item?.loading_charge ?? "-",
                     item?.unloading_charge ?? "-",
                     item?.misc ?? "-",
                  ]);
               });

               const sheetData = [headers, ...emiArr];

               const ws = XLSX.utils.aoa_to_sheet(sheetData);
               const wb = XLSX.utils.book_new();
               XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
               XLSX.writeFile(wb, "TRIP EXPENSES SUMMARY REPORT.xlsx");

               dispatch(backdropLoadingAction(false));
               reportPopup.onFalse();
            },
         })
      );
   };
   */

   const handleDownloadReport = (data) => {
      dispatch(backdropLoadingAction(true));

      const filter_params = { data };

      if (values.company) filter_params.company_id = values.company;
      if (values.fleet) filter_params.vehicle_id = values.fleet;
      if (values.customer) filter_params.customer_id = values.customer;
      if (values.tripCreatedFrom)
         filter_params.trip_created_from = values.tripCreatedFrom;
      if (values.tripCreatedTo)
         filter_params.trip_created_to = values.tripCreatedTo;

      dispatch(
         tripExpensesSummaryMasterAsync({
            data: filter_params,
            err: () => {
               dispatch(backdropLoadingAction(false));
            },

            done: (report_list) => {
               const headers = [
                  "S. No.",
                  "Vehicle Number",
                  "Company Name",
                  "Attached Location",
                  "Driver Name",
                  "HSD",
                  "Food Exp",
                  "Police",
                  "Parking",
                  "Loading Chg.",
                  "Unloading Chg.",
                  "Misc Exp.",
               ];

               let list = Object.values(report_list);

               // === Sort Before Grouping ===
               list.sort((a, b) => {
                  let comp = (a.company_name ?? "").localeCompare(b.company_name ?? "");
                  if (comp !== 0) return comp;

                  comp = (a.vehicle_no ?? "").localeCompare(b.vehicle_no ?? "");
                  if (comp !== 0) return comp;

                  comp = (a.driver_name ?? "").localeCompare(b.driver_name ?? "");
                  if (comp !== 0) return comp;

                  return 0;
               });

               // === GROUP KEY CHANGE HERE (use company_name) ===
               const groupKey = "company_name";

               const groups = {};

               list.forEach((item) => {
                  const key = item[groupKey] || "Unknown";

                  if (!groups[key]) {
                     groups[key] = {
                        items: [],
                        subtotal: {
                           hsd: 0,
                           food: 0,
                           police: 0,
                           parking: 0,
                           loading: 0,
                           unloading: 0,
                           misc: 0,
                        },
                     };
                  }

                  const g = groups[key];
                  const hsd = parseFloat(item.hsd) || 0;
                  const food = parseFloat(item.food) || 0;
                  const police = parseFloat(item.police) || 0;
                  const parking = parseFloat(item.parking) || 0;
                  const loading = parseFloat(item.loading_charge) || 0;
                  const unloading = parseFloat(item.unloading_charge) || 0;
                  const misc = parseFloat(item.misc) || 0;

                  g.items.push(item);

                  g.subtotal.hsd += hsd;
                  g.subtotal.food += food;
                  g.subtotal.police += police;
                  g.subtotal.parking += parking;
                  g.subtotal.loading += loading;
                  g.subtotal.unloading += unloading;
                  g.subtotal.misc += misc;
               });

               const finalRows = [];

               // === For Grand Total ===
               let grand = {
                  hsd: 0,
                  food: 0,
                  police: 0,
                  parking: 0,
                  loading: 0,
                  unloading: 0,
                  misc: 0,
               };

               // === Convert Groups to Rows ===
               Object.keys(groups).forEach((groupName) => {
                  const group = groups[groupName];

                  group.items.forEach((item, index) => {
                     finalRows.push([
                        index + 1,
                        item.vehicle_no ?? "-",
                        item.company_name ?? "-",
                        item.attached_location ?? "-",
                        item.driver_name ?? "-",
                        item.hsd ?? "-",
                        item.food ?? "-",
                        item.police ?? "-",
                        item.parking ?? "-",
                        item.loading_charge ?? "-",
                        item.unloading_charge ?? "-",
                        item.misc ?? "-",
                     ]);
                  });

                  // Subtotal Row
                  finalRows.push([
                     "",
                     "",
                     "",
                     "",
                     "Subtotal",
                     group.subtotal.hsd.toFixed(2),
                     group.subtotal.food.toFixed(2),
                     group.subtotal.police.toFixed(2),
                     group.subtotal.parking.toFixed(2),
                     group.subtotal.loading.toFixed(2),
                     group.subtotal.unloading.toFixed(2),
                     group.subtotal.misc.toFixed(2),
                  ]);

                  // Add to grand total
                  grand.hsd += group.subtotal.hsd;
                  grand.food += group.subtotal.food;
                  grand.police += group.subtotal.police;
                  grand.parking += group.subtotal.parking;
                  grand.loading += group.subtotal.loading;
                  grand.unloading += group.subtotal.unloading;
                  grand.misc += group.subtotal.misc;

                  // Blank Row
                  finalRows.push(["", "", "", "", "", "", "", "", "", "", "", ""]);
               });

               // === GRAND TOTAL ROW ===
               finalRows.push([
                  "",
                  "",
                  "",
                  "",
                  "GRAND TOTAL",
                  grand.hsd.toFixed(2),
                  grand.food.toFixed(2),
                  grand.police.toFixed(2),
                  grand.parking.toFixed(2),
                  grand.loading.toFixed(2),
                  grand.unloading.toFixed(2),
                  grand.misc.toFixed(2),
               ]);

               const sheetData = [headers, ...finalRows];

               const ws = XLSX.utils.aoa_to_sheet(sheetData);
               const wb = XLSX.utils.book_new();
               XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

               XLSX.writeFile(wb, "TRIP_EXPENSES_SUMMARY_REPORT.xlsx");

               dispatch(backdropLoadingAction(false));
               reportPopup.onFalse();
            },
         }),
      );
   };

   return (
      <div>
         <BodyHeader title="Trip Expenses Report" />
         <div className="px-3">
            <div className="row align-items-center">
               <div className="col-lg-2">
                  <CustomDropdown
                     label="Vehicle Number"
                     optionData={fleetData}
                     value={
                        fleetData.find((option) => option.value === values.fleet) ||
                        fleetData[0]
                     }
                     onChange={(value) => {
                        const val = Array.isArray(value) ? value[0]?.value : value?.value;
                        setFieldValue("fleet", val || "");
                     }}
                  />
               </div>
               <div className="col-lg-2">
                  <CustomDropdown
                     label="Company"
                     optionData={companyData}
                     value={
                        companyData.find((option) => option.value === values.company) ||
                        companyData[0]
                     }
                     onChange={(value) => {
                        const val = Array.isArray(value) ? value[0]?.value : value?.value;
                        setFieldValue("company", val || "");
                     }}
                  />
               </div>
               <div className="col-lg-2">
                  <CustomInput
                     label="Trip Created From"
                     inputType="date"
                     placeholder="From"
                     {...getFieldProps("tripCreatedFrom")}
                  />
               </div>
               <div className="col-lg-2">
                  <CustomInput
                     label="Trip Created To"
                     inputType="date"
                     placeholder="To"
                     {...getFieldProps("tripCreatedTo")}
                  />
               </div>

               <div className="col-lg-2 pt-2 mt-2 text-right">
                  <DownloadReportButton
                     title="Download Report"
                     onDownloadReport={handleDownloadReport}
                     confirmPopup={reportPopup}
                  />
               </div>
            </div>
            <CustomTable columns={columns} data={records} />
         </div>
      </div>
   );
}
